module.exports = __webpack_public_path__ + "static/img/1901_4.aced778.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1901_4.jpg
// module id = goTw
// module chunks = 1